import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Row } from '@yme/atoms/grid';
import { CardForEvents } from '@yme/molecules/cards/card-for-events';
import { getCommonLabels, getRTL } from '@yme/selectors/common';
import { buildKey } from '@yme/utils/common';
import { AspectRatio } from '@yme/utils/constants';
import { IndentWrapper } from '../Separator';
import { FlexibleColStyled } from './styled';
export function ThreeColumnsWithTopImages(props) {
    const { cards, isRemoveBottomIndent } = props;
    const labels = useSelector(getCommonLabels);
    const isRightToLeft = useSelector(getRTL);
    if (!cards.length) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, null,
            React.createElement(Row, null, cards.map((data, index) => {
                const title = data?.title || '';
                const description = data?.description || '';
                const link = data?.link || '';
                return (React.createElement(FlexibleColStyled, { key: buildKey(title || link, index), lg: 4, md: 6 },
                    React.createElement(CardForEvents, { cardProps: {
                            image: data.image,
                            title,
                            description,
                            link,
                            labelLink: labels?.common_readMore_link || '',
                            countLineVisible: 'initial',
                            isFullHeaderVisible: true,
                            isImageBackgroundHidden: true,
                            aspectRatio: AspectRatio.RectangleLevel3,
                        }, isRightToLeft: isRightToLeft })));
            })))));
}
ThreeColumnsWithTopImages.displayName = 'ThreeColumnsWithTopImages_AEMComponent';
